
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta } from "/app/pages/index.vue?macro=true";
import { default as _91_46_46_46slug_93_45_91id_930M0xAruqaJ9ZkY2lweEsSNeOOnBio0qmj9uwMaG428YMeta } from "/app/pages/b/[...categories]/[...slug]-[id].vue?macro=true";
import { default as bTeLVARzfDYmwhyESr9vBgCfDZol8atQe27krz_45QpcLMMeta } from "/app/pages/b.vue?macro=true";
import { default as _91_46_46_46slug_93LaeZW8hEuN0ItwtN4u_45Jrj80Qx_frUlG4Ic7cAGAqgcMeta } from "/app/pages/c/[...categories]/[...slug].vue?macro=true";
import { default as _91_46_46_46slug_93_45_91id_93Wj2iuH6BN4_45FJgwGCtJHVaLxYy5XpTGAD7mAdsmE6w8Meta } from "/app/pages/c/[...categories]/[...slug]-[id].vue?macro=true";
import { default as cEL7G_jLn7gBKcNlLDkl6FpQJQU8H_45P_A9rZrPlGeUc0Meta } from "/app/pages/c.vue?macro=true";
import { default as _4040t2rYAnSkd8kYnodTPSbPcA6Q8AhTcYAZVNhIAW6D78Meta } from "/app/pages/404.vue?macro=true";
import { default as cartbqvKlr4P3KWVI39lVm4PanL_ftLfoLwpA5GLzZKyC94Meta } from "/app/pages/cart.vue?macro=true";
import { default as searchWiCwPORWRkcZm1zH29UWKNMF4Vb5hM_q5Mi2yI40hlcMeta } from "/app/pages/search.vue?macro=true";
import { default as signupXDZ9vem3RhITR7dUmFJxupvJgksTCjysSig_ObPaBwEMeta } from "/app/pages/signup.vue?macro=true";
import { default as profileaoKsz5e523syACRfzuI3T7AUyrbLBLKSNMAtddwLwyQMeta } from "/app/pages/account/profile.vue?macro=true";
import { default as _91id_93BlZVm1ids_JPb5Z_456T52vqhCHTd7EI4xHE8kvwEi__45IMeta } from "/app/pages/account/orders/[id].vue?macro=true";
import { default as indexFTgIbYcxhaesYBFQ2Ua_454qVcuF_n_fR1Id4icjy4nfEMeta } from "/app/pages/account/orders/index.vue?macro=true";
import { default as subscriptions6I_b7H5vyNka3wfQLDWNQM3fuYVK_SdW_45A4FbKoN4BsMeta } from "/app/modules/subscription/pages/subscriptions.vue?macro=true";
import { default as account8qjjsMH2Z_4583nGmUzgn0GenZn4EgfKFuzSOEohZZlYkMeta } from "/app/pages/account.vue?macro=true";
import { default as successs_45Ty_pSos_cJey7loh3TOu085H8Zj1qbAiZPQc9ixQ0Meta } from "/app/pages/success.vue?macro=true";
import { default as checkoutrJOJ_qEKslhH7u_45okx_45tCaYkZe6jupNB2VSAVuoHgEMMeta } from "/app/pages/checkout.vue?macro=true";
import { default as _91slug_93V2kSp1hht36O8U3TNac8uaofRCrY8VyrphP0yesGoW0Meta } from "/app/pages/d/[slug].vue?macro=true";
import { default as wishlistv2I1MUjbTRx0iGV3nESzWMuBlZI0Cfik4UsNxZw81IkMeta } from "/app/pages/wishlist.vue?macro=true";
import { default as _91_46_46_46slug_93VcbDAaFFE_y8JmcJ7kitGB4I90YVYmdPZvIp4GzB1GMMeta } from "/app/pages/p/[...slug].vue?macro=true";
import { default as precheckouto84IRfk5wLcYD3qIqp_45oMoSDAIKvIhdoKVDFjf5UJPoMeta } from "/app/pages/precheckout.vue?macro=true";
import { default as storefinderaO7TOWgZID20s_45vtwhofjucjbqDa4LQ6qLJaFlSP7gIMeta } from "/app/pages/storefinder.vue?macro=true";
import { default as faq_45overviewBlFOiBgezegT13heptzggshDItfLw5w5Lv4_45d_Tcfo4Meta } from "/app/pages/faq-overview.vue?macro=true";
import { default as index6puYh5ikrp5HtgDGK_4540YLlcWph3MNLDaHx7wdtQnVsMeta } from "/app/pages/signin/index.vue?macro=true";
import { default as indexGpQ6uLC1m1tLroXB0IeZYPeFn069i2BQQ21ZfxohdlEMeta } from "/app/pages/[scope]/index.vue?macro=true";
import { default as callbackP8FMLMgY5uhJBZXNmtvHRoWuspIlaA3YLPJOmxQZrzwMeta } from "/app/pages/signin/callback.vue?macro=true";
import { default as indexfpxTgDma1bc8tysgRfJ3Qe2GeBCyWY354ZJQTxEqdIoMeta } from "/app/pages/s/[...slug]/index.vue?macro=true";
import { default as _91_46_46_46shopId_934U0x8jI02rZCL4_45gY4LXmNlcS0jxE9IR3hFgScrQ2v8Meta } from "/app/pages/notify/doi/[...shopId].vue?macro=true";
import { default as _91_46_46_46shopId_93IYhS0skgh5l_bDS0zNdlmwTJbWWFXhG6OihOOXFoSyoMeta } from "/app/pages/newsletter/doi/[...shopId].vue?macro=true";
import { default as _91_46_46_46shopId_93jhumGFMHuvO_WpP3xDRHZvpYBpuLLJmlfsRtnSPJcDYMeta } from "/app/pages/newsletter/unsubscribe/[...shopId].vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    meta: indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta || {},
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "b___en-eu",
    path: "/en-eu/b",
    component: () => import("/app/pages/b.vue"),
    children: [
  {
    name: "b-categories-slug-id___en-eu",
    path: ":categories([^/]*)*/:slug(.*)*-:id()",
    meta: _91_46_46_46slug_93_45_91id_930M0xAruqaJ9ZkY2lweEsSNeOOnBio0qmj9uwMaG428YMeta || {},
    component: () => import("/app/pages/b/[...categories]/[...slug]-[id].vue")
  }
]
  },
  {
    name: "b___pl-pl",
    path: "/pl-pl/b",
    component: () => import("/app/pages/b.vue"),
    children: [
  {
    name: "b-categories-slug-id___pl-pl",
    path: ":categories([^/]*)*/:slug(.*)*-:id()",
    meta: _91_46_46_46slug_93_45_91id_930M0xAruqaJ9ZkY2lweEsSNeOOnBio0qmj9uwMaG428YMeta || {},
    component: () => import("/app/pages/b/[...categories]/[...slug]-[id].vue")
  }
]
  },
  {
    name: "c___en-eu",
    path: "/en-eu/c",
    component: () => import("/app/pages/c.vue"),
    children: [
  {
    name: "c-categories-slug___en-eu",
    path: ":categories([^/]*)*/:slug(.*)*",
    meta: _91_46_46_46slug_93LaeZW8hEuN0ItwtN4u_45Jrj80Qx_frUlG4Ic7cAGAqgcMeta || {},
    component: () => import("/app/pages/c/[...categories]/[...slug].vue")
  },
  {
    name: "c-categories-slug-id___en-eu",
    path: ":categories([^/]*)*/:slug(.*)*-:id()",
    meta: _91_46_46_46slug_93_45_91id_93Wj2iuH6BN4_45FJgwGCtJHVaLxYy5XpTGAD7mAdsmE6w8Meta || {},
    component: () => import("/app/pages/c/[...categories]/[...slug]-[id].vue")
  }
]
  },
  {
    name: "c___pl-pl",
    path: "/pl-pl/c",
    component: () => import("/app/pages/c.vue"),
    children: [
  {
    name: "c-categories-slug___pl-pl",
    path: ":categories([^/]*)*/:slug(.*)*",
    meta: _91_46_46_46slug_93LaeZW8hEuN0ItwtN4u_45Jrj80Qx_frUlG4Ic7cAGAqgcMeta || {},
    component: () => import("/app/pages/c/[...categories]/[...slug].vue")
  },
  {
    name: "c-categories-slug-id___pl-pl",
    path: ":categories([^/]*)*/:slug(.*)*-:id()",
    meta: _91_46_46_46slug_93_45_91id_93Wj2iuH6BN4_45FJgwGCtJHVaLxYy5XpTGAD7mAdsmE6w8Meta || {},
    component: () => import("/app/pages/c/[...categories]/[...slug]-[id].vue")
  }
]
  },
  {
    name: "404___en-eu",
    path: "/en-eu/404",
    meta: _4040t2rYAnSkd8kYnodTPSbPcA6Q8AhTcYAZVNhIAW6D78Meta || {},
    component: () => import("/app/pages/404.vue")
  },
  {
    name: "404___pl-pl",
    path: "/pl-pl/404",
    meta: _4040t2rYAnSkd8kYnodTPSbPcA6Q8AhTcYAZVNhIAW6D78Meta || {},
    component: () => import("/app/pages/404.vue")
  },
  {
    name: "cart___en-eu",
    path: "/en-eu/cart",
    meta: cartbqvKlr4P3KWVI39lVm4PanL_ftLfoLwpA5GLzZKyC94Meta || {},
    component: () => import("/app/pages/cart.vue")
  },
  {
    name: "cart___pl-pl",
    path: "/pl-pl/cart",
    meta: cartbqvKlr4P3KWVI39lVm4PanL_ftLfoLwpA5GLzZKyC94Meta || {},
    component: () => import("/app/pages/cart.vue")
  },
  {
    name: "index___en-eu",
    path: "/en-eu",
    meta: indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta || {},
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "index___pl-pl",
    path: "/pl-pl",
    meta: indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta || {},
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "search___en-eu",
    path: "/en-eu/search",
    meta: searchWiCwPORWRkcZm1zH29UWKNMF4Vb5hM_q5Mi2yI40hlcMeta || {},
    component: () => import("/app/pages/search.vue")
  },
  {
    name: "search___pl-pl",
    path: "/pl-pl/search",
    meta: searchWiCwPORWRkcZm1zH29UWKNMF4Vb5hM_q5Mi2yI40hlcMeta || {},
    component: () => import("/app/pages/search.vue")
  },
  {
    name: "signup___en-eu",
    path: "/en-eu/signup",
    meta: signupXDZ9vem3RhITR7dUmFJxupvJgksTCjysSig_ObPaBwEMeta || {},
    component: () => import("/app/pages/signup.vue")
  },
  {
    name: "signup___pl-pl",
    path: "/pl-pl/signup",
    meta: signupXDZ9vem3RhITR7dUmFJxupvJgksTCjysSig_ObPaBwEMeta || {},
    component: () => import("/app/pages/signup.vue")
  },
  {
    name: "account___en-eu",
    path: "/en-eu/account",
    meta: account8qjjsMH2Z_4583nGmUzgn0GenZn4EgfKFuzSOEohZZlYkMeta || {},
    component: () => import("/app/pages/account.vue"),
    children: [
  {
    name: "account-profile___en-eu",
    path: "profile",
    meta: profileaoKsz5e523syACRfzuI3T7AUyrbLBLKSNMAtddwLwyQMeta || {},
    component: () => import("/app/pages/account/profile.vue")
  },
  {
    name: "account-orders-id___en-eu",
    path: "orders/:id()",
    meta: _91id_93BlZVm1ids_JPb5Z_456T52vqhCHTd7EI4xHE8kvwEi__45IMeta || {},
    component: () => import("/app/pages/account/orders/[id].vue")
  },
  {
    name: "account-orders___en-eu",
    path: "orders",
    meta: indexFTgIbYcxhaesYBFQ2Ua_454qVcuF_n_fR1Id4icjy4nfEMeta || {},
    component: () => import("/app/pages/account/orders/index.vue")
  },
  {
    name: "subscription-overview___en-eu",
    path: "subscriptions",
    meta: subscriptions6I_b7H5vyNka3wfQLDWNQM3fuYVK_SdW_45A4FbKoN4BsMeta || {},
    component: () => import("/app/modules/subscription/pages/subscriptions.vue")
  }
]
  },
  {
    name: "account___pl-pl",
    path: "/pl-pl/account",
    meta: account8qjjsMH2Z_4583nGmUzgn0GenZn4EgfKFuzSOEohZZlYkMeta || {},
    component: () => import("/app/pages/account.vue"),
    children: [
  {
    name: "account-profile___pl-pl",
    path: "profile",
    meta: profileaoKsz5e523syACRfzuI3T7AUyrbLBLKSNMAtddwLwyQMeta || {},
    component: () => import("/app/pages/account/profile.vue")
  },
  {
    name: "account-orders-id___pl-pl",
    path: "orders/:id()",
    meta: _91id_93BlZVm1ids_JPb5Z_456T52vqhCHTd7EI4xHE8kvwEi__45IMeta || {},
    component: () => import("/app/pages/account/orders/[id].vue")
  },
  {
    name: "account-orders___pl-pl",
    path: "orders",
    meta: indexFTgIbYcxhaesYBFQ2Ua_454qVcuF_n_fR1Id4icjy4nfEMeta || {},
    component: () => import("/app/pages/account/orders/index.vue")
  },
  {
    name: "subscription-overview___pl-pl",
    path: "subscriptions",
    component: () => import("/app/modules/subscription/pages/subscriptions.vue")
  }
]
  },
  {
    name: "success___en-eu",
    path: "/en-eu/success",
    meta: successs_45Ty_pSos_cJey7loh3TOu085H8Zj1qbAiZPQc9ixQ0Meta || {},
    component: () => import("/app/pages/success.vue")
  },
  {
    name: "success___pl-pl",
    path: "/pl-pl/success",
    meta: successs_45Ty_pSos_cJey7loh3TOu085H8Zj1qbAiZPQc9ixQ0Meta || {},
    component: () => import("/app/pages/success.vue")
  },
  {
    name: "checkout___en-eu",
    path: "/en-eu/checkout",
    meta: checkoutrJOJ_qEKslhH7u_45okx_45tCaYkZe6jupNB2VSAVuoHgEMMeta || {},
    component: () => import("/app/pages/checkout.vue")
  },
  {
    name: "checkout___pl-pl",
    path: "/pl-pl/checkout",
    meta: checkoutrJOJ_qEKslhH7u_45okx_45tCaYkZe6jupNB2VSAVuoHgEMMeta || {},
    component: () => import("/app/pages/checkout.vue")
  },
  {
    name: "d-slug___en-eu",
    path: "/en-eu/d/:slug()",
    meta: _91slug_93V2kSp1hht36O8U3TNac8uaofRCrY8VyrphP0yesGoW0Meta || {},
    component: () => import("/app/pages/d/[slug].vue")
  },
  {
    name: "d-slug___pl-pl",
    path: "/pl-pl/d/:slug()",
    meta: _91slug_93V2kSp1hht36O8U3TNac8uaofRCrY8VyrphP0yesGoW0Meta || {},
    component: () => import("/app/pages/d/[slug].vue")
  },
  {
    name: "wishlist___en-eu",
    path: "/en-eu/wishlist",
    meta: wishlistv2I1MUjbTRx0iGV3nESzWMuBlZI0Cfik4UsNxZw81IkMeta || {},
    component: () => import("/app/pages/wishlist.vue")
  },
  {
    name: "wishlist___pl-pl",
    path: "/pl-pl/wishlist",
    meta: wishlistv2I1MUjbTRx0iGV3nESzWMuBlZI0Cfik4UsNxZw81IkMeta || {},
    component: () => import("/app/pages/wishlist.vue")
  },
  {
    name: "p-slug___en-eu",
    path: "/en-eu/p/:slug(.*)*",
    meta: _91_46_46_46slug_93VcbDAaFFE_y8JmcJ7kitGB4I90YVYmdPZvIp4GzB1GMMeta || {},
    component: () => import("/app/pages/p/[...slug].vue")
  },
  {
    name: "p-slug___pl-pl",
    path: "/pl-pl/p/:slug(.*)*",
    meta: _91_46_46_46slug_93VcbDAaFFE_y8JmcJ7kitGB4I90YVYmdPZvIp4GzB1GMMeta || {},
    component: () => import("/app/pages/p/[...slug].vue")
  },
  {
    name: "precheckout___en-eu",
    path: "/en-eu/precheckout",
    meta: precheckouto84IRfk5wLcYD3qIqp_45oMoSDAIKvIhdoKVDFjf5UJPoMeta || {},
    component: () => import("/app/pages/precheckout.vue")
  },
  {
    name: "precheckout___pl-pl",
    path: "/pl-pl/precheckout",
    meta: precheckouto84IRfk5wLcYD3qIqp_45oMoSDAIKvIhdoKVDFjf5UJPoMeta || {},
    component: () => import("/app/pages/precheckout.vue")
  },
  {
    name: "storefinder___en-eu",
    path: "/en-eu/storefinder",
    meta: storefinderaO7TOWgZID20s_45vtwhofjucjbqDa4LQ6qLJaFlSP7gIMeta || {},
    component: () => import("/app/pages/storefinder.vue")
  },
  {
    name: "storefinder___pl-pl",
    path: "/pl-pl/storefinder",
    meta: storefinderaO7TOWgZID20s_45vtwhofjucjbqDa4LQ6qLJaFlSP7gIMeta || {},
    component: () => import("/app/pages/storefinder.vue")
  },
  {
    name: "faq-overview___en-eu",
    path: "/en-eu/faq-overview",
    component: () => import("/app/pages/faq-overview.vue")
  },
  {
    name: "faq-overview___pl-pl",
    path: "/pl-pl/faq-overview",
    component: () => import("/app/pages/faq-overview.vue")
  },
  {
    name: "signin___en-eu",
    path: "/en-eu/signin",
    component: () => import("/app/pages/signin/index.vue")
  },
  {
    name: "signin___pl-pl",
    path: "/pl-pl/signin",
    component: () => import("/app/pages/signin/index.vue")
  },
  {
    name: "scope___en-eu",
    path: "/en-eu/:scope()",
    meta: indexGpQ6uLC1m1tLroXB0IeZYPeFn069i2BQQ21ZfxohdlEMeta || {},
    component: () => import("/app/pages/[scope]/index.vue")
  },
  {
    name: "scope___pl-pl",
    path: "/pl-pl/:scope()",
    meta: indexGpQ6uLC1m1tLroXB0IeZYPeFn069i2BQQ21ZfxohdlEMeta || {},
    component: () => import("/app/pages/[scope]/index.vue")
  },
  {
    name: "signin-callback___en-eu",
    path: "/en-eu/signin/callback",
    component: () => import("/app/pages/signin/callback.vue")
  },
  {
    name: "signin-callback___pl-pl",
    path: "/pl-pl/signin/callback",
    component: () => import("/app/pages/signin/callback.vue")
  },
  {
    name: "s-slug___en-eu",
    path: "/en-eu/s/:slug(.*)*",
    meta: indexfpxTgDma1bc8tysgRfJ3Qe2GeBCyWY354ZJQTxEqdIoMeta || {},
    component: () => import("/app/pages/s/[...slug]/index.vue")
  },
  {
    name: "s-slug___pl-pl",
    path: "/pl-pl/s/:slug(.*)*",
    meta: indexfpxTgDma1bc8tysgRfJ3Qe2GeBCyWY354ZJQTxEqdIoMeta || {},
    component: () => import("/app/pages/s/[...slug]/index.vue")
  },
  {
    name: "notify-doi-shopId___en-eu",
    path: "/en-eu/notify/doi/:shopId(.*)*",
    component: () => import("/app/pages/notify/doi/[...shopId].vue")
  },
  {
    name: "notify-doi-shopId___pl-pl",
    path: "/pl-pl/notify/doi/:shopId(.*)*",
    component: () => import("/app/pages/notify/doi/[...shopId].vue")
  },
  {
    name: "newsletter-doi-shopId___en-eu",
    path: "/en-eu/newsletter/doi/:shopId(.*)*",
    meta: _91_46_46_46shopId_93IYhS0skgh5l_bDS0zNdlmwTJbWWFXhG6OihOOXFoSyoMeta || {},
    component: () => import("/app/pages/newsletter/doi/[...shopId].vue")
  },
  {
    name: "newsletter-doi-shopId___pl-pl",
    path: "/pl-pl/newsletter/doi/:shopId(.*)*",
    meta: _91_46_46_46shopId_93IYhS0skgh5l_bDS0zNdlmwTJbWWFXhG6OihOOXFoSyoMeta || {},
    component: () => import("/app/pages/newsletter/doi/[...shopId].vue")
  },
  {
    name: "newsletter-unsubscribe-shopId___en-eu",
    path: "/en-eu/newsletter/unsubscribe/:shopId(.*)*",
    component: () => import("/app/pages/newsletter/unsubscribe/[...shopId].vue")
  },
  {
    name: "newsletter-unsubscribe-shopId___pl-pl",
    path: "/pl-pl/newsletter/unsubscribe/:shopId(.*)*",
    component: () => import("/app/pages/newsletter/unsubscribe/[...shopId].vue")
  }
]